<template>
    <div class="form-view">
        <section>
            <h2 class="text-center">{{'Rediger ' + selectedUserSelectList.listName}}</h2>
            <div class="form">
                <div class="grid-x">
                    <div class="large-1 medium-1 small-1 cell flexbox-center">
                        <icon class="user small-svg fill-dark-gray" name="drop-down-list" />
                    </div>
                    <div class="large-3 medium-3 small-3 cell border-bottom">
                        <p class="custom-modal-text-alignment">Emne på liste</p>
                    </div>
                    <div class="auto cell border-bottom">
                        <input type="text" v-model="enteredItemName">
                    </div>
                </div>
            </div>
            <div class="form">
                <div class="grid-x">
                    <div class="large-1 medium-1 small-1 cell flexbox-center">
                        <icon class="user small-svg fill-dark-gray" name="lightbulb" />
                    </div>
                    <div class="large-3 medium-3 small-3 cell border-bottom">
                        <p class="custom-modal-text-alignment">Anvendes</p>
                    </div>
                    <div class="auto cell border-bottom">
                        <input v-if="selectedUserSelectListItem.used === true" type="text" disabled value="Anvendes. Kan ikke slettes"/>
                        <input v-else type="text" disabled value="Anvendes ikke. Kan slettes"/>
                    </div>
                </div>
            </div>
            <div class="form">
                <div class="grid-x">
                    <div class="large-1 medium-1 small-1 cell flexbox-center">
                        <icon class="user small-svg fill-dark-gray" name="tags" />
                    </div>
                    <div class="large-3 medium-3 small-3 cell border-bottom flexbox-align-items">
                        <p class="custom-modal-text-alignment">Tags</p>
                    </div>
                    <div class="auto cell border-bottom">
                        <multiselect
                            v-model="selectedTags"
                            :options="selectTagList"
                            :multiple="true"
                            placeholder="Vælg et eller flere tags"
                            :close-on-select="false"
                            :clear-on-select="false"
                            :searchable="false"
                            label="description"
                            select-label=""
                            deselect-label=""
                            selected-label=""
                            track-by="tagName"
                            :preselect-first="false"
                        />
                    </div>
                </div>
            </div>
            <div v-if="isProblemType" class="form">
                <div class="grid-x">
                    <div class="large-1 medium-1 small-1 cell flexbox-center">
                        <icon class="user small-svg fill-dark-gray" name="template" />
                    </div>
                    <div class="large-3 medium-3 small-3 cell border-bottom flexbox-align-items">
                        <p class="custom-modal-text-alignment">Opgaveskabelon</p>
                    </div>
                    <div class="auto cell border-bottom">
                        <multiselect
                        v-model="selectTaskTemplate"
                        :options="selectTaskTemplateList"
                        :multiple="false"
                        placeholder="Vælg en opgaveskabelon"
                        :searchable="false"
                        label="name"
                        select-label=""
                        deselect-label="Klik for at fravælge"
                        selected-label=""
                        track-by="taskId"
                        :preselect-first="false"
                        />
                    </div>
                </div>
                <div class="grid-x">
                    <div class="large-1 medium-1 small-1 cell flexbox-center"/>
                    <div class="large-3 medium-3 small-3 cell border-bottom flexbox-align-items" />
                    <div class="auto cell border-bottom">
                        <small><em>Bemærk: Der kan kun vælges skabeloner med sagsbehandler på!</em></small>
                    </div>
                </div>
            </div>
            <div v-if="isProblemType" class="form">
                <div class="grid-x">
                    <div class="large-1 medium-1 small-1 cell flexbox-center">
                        <icon class="user small-svg fill-dark-gray" name="template" />
                    </div>
                    <div class="large-3 medium-3 small-3 cell border-bottom flexbox-align-items">
                        <p class="custom-modal-text-alignment">Sagsbehandler</p>
                    </div>
                    <div class="auto cell border-bottom">
                        <multiselect
                        v-model="selectCaseWorker"
                        :options="selectCaseWorkerList"
                        :multiple="false"
                        placeholder="Vælg en sagsbehandler"
                        :searchable="false"
                        label="name"
                        select-label=""
                        deselect-label="Klik for at fravælge"
                        selected-label=""
                        track-by="userId"
                        :preselect-first="false"
                        />
                    </div>
                </div>
                <div class="grid-x">
                    <div class="large-1 medium-1 small-1 cell flexbox-center"/>
                    <div class="large-3 medium-3 small-3 cell border-bottom flexbox-align-items" />
                    <div class="auto cell border-bottom">
                        <small><em>Bemærk: Ved skifte af skabelon vælges sagsbehandler fra skabelon!</em></small>
                    </div>
                </div>
            </div>
            <div v-if="isProblemType" class="form">
                <div class="grid-x">
                    <div class="large-1 medium-1 small-1 cell flexbox-center">
                        <icon class="small-svg" name="hide" />
                    </div>
                    <div class="large-3 medium-3 small-3 cell border-bottom flexbox-align-items">
                        <p class="custom-modal-text-alignment">Synlig eksternt</p>
                    </div>
                    <div class="auto cell border-bottom">
                        <switches v-model="externalVisibility" theme="custom" type-bold="false" color="blue" />
                    </div>
                </div>
            </div>
            <div v-if="isProblemType" class="form">
                <div class="grid-x">
                    <div class="large-1 medium-1 small-1 cell flexbox-center">
                    </div>
                    <div class="large-3 medium-3 small-3 cell border-bottom flexbox-align-items">
                        <p class="custom-modal-text-alignment">Hjælpetekst</p>
                    </div>
                    <div class="auto cell border-bottom">
                        <base-editor id="johnny" editorLang="da" v-model="helpText"></base-editor>
                    </div>
                </div>
            </div>
            <div class="text-center buttons-modal">
                <a @click="updateItem(false)">
                    <span>Gem</span>
                </a>
                <a v-if="selectedUserSelectListItem.used === false" @click="updateItem(true)">
                    <span>Slet</span>
                </a>
                <a @click="closeModal()">Fortryd</a>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Switches from 'vue-switches'
import Multiselect from 'vue-multiselect'
import axios from '../../../../store/api.js'
import BaseEditor from '@/components/base/BaseEditor.vue'

export default {
    name: 'settings-modal-userselectlistitem',
    components: {
        Switches,
        Multiselect,
        BaseEditor
    },
    props: [
        'data'
    ],
    data () {
        return {
            enteredItemName: null,
            selectedTags: null,
            selectTaskTemplate: null,
            selectCaseWorker: null,
            selectCaseWorkerList: [],
            externalVisibility: false,
            helpText: ''
        }
    },
    computed: {
        ...mapGetters({
            selectedUserSelectListItem: 'getSelectedUserSelectListItem',
            selectedUserSelectList: 'getSelectedUserSelectList',
            selectedBusinessAreaSystemName: 'getSelectedBusinessAreaSystemName',
            applicationSettings: 'getApplicationSettingsDrive',
            userInfo: 'userInfo'
        }),

        isActivityType () {
            return this.selectedUserSelectList.systemName === 'activitytype'
        },
        isEstateType () {
            return this.selectedUserSelectList.systemName === 'estatetype'
        },
        isClientType () {
            return this.selectedUserSelectList.systemName === 'clienttype'
        },
        isProblemType () {
            return this.selectedUserSelectList.systemName === 'problemtype'
        },
        isWeatherType () {
            return this.selectedUserSelectList.systemName === 'weathertype'
        },

        selectTagList () {
            if (this.applicationSettings && this.applicationSettings.length > 0) {
                const lookups = this.applicationSettings.find((a) => a.category === 'lookups')
                if (lookups) {
                    if (this.selectedUserSelectList.systemName === 'activitytype') {
                        return lookups.value.tagList.filter((t) => t.worksOnActivityType === true)
                    }
                    if (this.selectedUserSelectList.systemName === 'clienttype') {
                        return lookups.value.tagList.filter((t) => t.worksOnClientType === true)
                    }
                    if (this.selectedUserSelectList.systemName === 'problemtype') {
                        return lookups.value.tagList.filter((t) => t.worksOnProblemType === true)
                    }
                }
                return []
            }
            return []
        },
        selectTaskTemplateList () {
            if (this.applicationSettings && this.applicationSettings.length > 0) {
                const lookups = this.applicationSettings.find((a) => a.category === 'lookups')
                if (lookups) {
                    if (this.selectedUserSelectList.systemName === 'problemtype') {
                        return lookups.value.taskTemplateList.filter((t) => t.businessAreaSystemName === this.selectedBusinessAreaSystemName)
                    }
                }
                return []
            }
            return []
        }
    },
    methods: {
        ...mapActions({
            setSelectedUserSelectListItem: 'setSelectedUserSelectListItem',
            setSelectedUserSelectList: 'setSelectedUserSelectList',
            createUpdateActivityType: 'createUpdateActivityType',
            createUpdateClientType: 'createUpdateClientType',
            createUpdateEstateType: 'createUpdateEstateType',
            createUpdateProblemType: 'createUpdateProblemType',
            createUpdateWeatherType: 'createUpdateWeatherType',
            setApplicationSettingsDrive: 'setApplicationSettingsDrive'
        }),

        updateItem (deleteItem) {
            if (this.enteredItemName && this.enteredItemName.length > 0) {
                if (this.selectedUserSelectList.systemName === 'activitytype') {
                    this.createUpdateActivityType({
                        deleteListItem: deleteItem,
                        cActivityTypeId: this.selectedUserSelectListItem.typeId,
                        businessAreaTypeId: this.selectedUserSelectList.businessAreaTypeId,
                        code: 0,
                        description: this.enteredItemName,
                        tagList: this.selectedTags
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                this.$emit('close')
                            }
                        })
                } else if (this.selectedUserSelectList.systemName === 'clienttype') {
                    this.createUpdateClientType({
                        deleteListItem: deleteItem,
                        cClientTypeId: this.selectedUserSelectListItem.typeId,
                        businessAreaTypeId: this.selectedUserSelectList.businessAreaTypeId,
                        description: this.enteredItemName,
                        tagList: this.selectedTags
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                this.$emit('close')
                            }
                        })
                } else if (this.selectedUserSelectList.systemName === 'estatetype') {
                    this.createUpdateEstateType({
                        deleteListItem: deleteItem,
                        cEstateTypeId: this.selectedUserSelectListItem.typeId,
                        businessAreaTypeId: this.selectedUserSelectList.businessAreaTypeId,
                        description: this.enteredItemName
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                this.$emit('close')
                            }
                        })
                } else if (this.selectedUserSelectList.systemName === 'problemtype') {
                    console.log('Updating problem type, helpText:', this.helpText)
                    this.createUpdateProblemType({
                        deleteListItem: deleteItem,
                        cProblemTypeId: this.selectedUserSelectListItem.typeId,
                        businessAreaTypeId: this.selectedUserSelectList.businessAreaTypeId,
                        description: this.enteredItemName,
                        tagList: this.selectedTags,
                        isPublic: this.externalVisibility,
                        taskTemplateId: this.selectTaskTemplate ? this.selectTaskTemplate.taskId : null,
                        defaultOwnerUserId: this.selectCaseWorker ? this.selectCaseWorker.userId : null,
                        publicDescription: this.helpText
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                this.$emit('close')
                            }
                        })
                } else if (this.selectedUserSelectList.systemName === 'weathertype') {
                    this.createUpdateWeatherType({
                        deleteListItem: deleteItem,
                        cWeatherTypeId: this.selectedUserSelectListItem.typeId,
                        businessAreaTypeId: this.selectedUserSelectList.businessAreaTypeId,
                        description: this.enteredItemName
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                this.$emit('close')
                            }
                        })
                }
                this.enteredItemName = null
                this.externalVisibility = false
                this.helpText = ''
            }
        },
        closeModal () {
            this.$emit('close')
        }
    },
    watch: {
        selectTaskTemplate (newTemplate) {
            if (newTemplate && newTemplate.ownerUserId) {
                this.selectCaseWorker = this.selectCaseWorker = this.selectCaseWorkerList.find(worker => worker.userId === newTemplate.ownerUserId)
            }
        }
    },
    created () {
        this.enteredItemName = this.selectedUserSelectListItem.description
        this.selectedTags = this.selectedUserSelectListItem.tagList
        this.selectTaskTemplate = this.selectTaskTemplateList.find(i => i.taskId === this.selectedUserSelectListItem.taskTemplateId)
        this.externalVisibility = this.selectedUserSelectListItem.isPublic
        this.helpText = this.selectedUserSelectListItem.publicDescription

        if (this.applicationSettings && this.applicationSettings.length === 0) {
            this.setApplicationSettingsDrive()
        }

        axios.post('/Account/GetAssociatedOrganizationUserList', {
            'organizationUsersId': this.userInfo.selectedOrganization,
            'userGroupSystemNameFilterGroupList': [
                'caseOwner_' + this.selectedBusinessAreaSystemName
            ]
        })
            .then((response) => {
                if (response.status === 200) {
                    this.selectCaseWorkerList = response.data.map((u) => {
                        return {
                            name: u.name,
                            userId: u.userId
                        }
                    })
                    this.selectCaseWorker = this.selectCaseWorkerList.find(i => i.userId === this.selectedUserSelectListItem.defaultOwnerUserId)
                } else {
                    console.error('Error fetching case owners:', response)
                }
            })
            .catch((error) => {
                console.error('Error fetching case owners:', error)
            })
    }
}
</script>

<style lang="scss">
    .multiselect__tags {
        max-width: 460px;
    }
    .vue-switcher input {
        margin-bottom: 0;
        margin-top: 0;
    }
    .vue-switcher--bold div {
        top: 0 !important;
    }
    .form-view section .form .base-editor input,
    .form-view section .form .base-editor button {
        min-width: unset;
    }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/pages/administration/drive/administration-modal-selectlistitem-drive.vue